function getFormData(form) {
  var elements = form.elements;
  var formData = {};
  for (var key in elements) {
    if (window.isNaN(key)) break;
    var element = elements[key];
    var name = element.name;

    if (name && element.type && element.type.toLocaleLowerCase() === "checkbox") {
      if (formData[name] === undefined)
        formData[name] = [];
      if (element.checked)
        formData[name].push(element.value);
    } else if (name && element.type && element.type.toLocaleLowerCase() === "radio") {
      if (element.checked) {
        formData[name] = element.value;
      }
    } else if (name && element.value) {
      formData[name] = element.value;
      if (formData[name] === "true") {
        formData[name] = true;
      } else if (formData[name] === "false") {
        formData[name] = false;
      }
    }
  }
  return formData;
}

const getQueryString = (obj) => {
  var keys = Object.keys(obj) || [];
  return keys.map(k => `${k}=${obj[k] instanceof Array ? obj[k].join(",") : obj[k]}`).join("&");
};

const getQueryData = (string) => {
  var data = {};
  var queryStrings = string.replace("?", "").split("&") || [];
  queryStrings.forEach(kv => {
    var k = kv.split("=")[0];
    var v = kv.split("=")[1];
    if (k) data[k] = v;
  });
  return data;
};


const cleansing = (obj) => {
  const _new = [];
  Object.keys(obj).filter(k => obj[k]).forEach(k => {
    _new[k] = obj[k];
  });
  return _new;
};


export { getFormData, getQueryData, getQueryString, cleansing };

